import React from 'react';
import {Button} from 'react-bootstrap';

const ContractDeliverablesEditButtons = ({item, isSupplier, editRow, deleteRow}) => {
    const show = (
        (isSupplier && item.created_by_supplier) ||
        (!isSupplier && !item.created_by_supplier)
    );

    if (!show) {
        return null;
    }

    return (
        <div>
            <Button onClick={() => editRow(item.id)}
                    bsStyle="primary"
                    bsSize="xsmall">
                <i className="fa fa-pencil"></i>
            </Button>&nbsp;
            <Button onClick={() => deleteRow(item.id)}
                    bsStyle="danger"
                    bsSize="xsmall">
                <i className="fa fa-trash"></i>
            </Button>
        </div>
    );
}

export default ContractDeliverablesEditButtons;